import { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";

const AddFaq = () => {
    const qstnRef = useRef();
    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");
    const [file, setFile] = useState(null);

    const { auth } = useAuth();
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        qstnRef.current.focus();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const form = new FormData();
            form.append("question", question);
            form.append("answer", answer);
            if (file) {
                form.append("uploaded_file", file);
            }
            console.log(JSON.stringify(Object.fromEntries(form)));
            const headers = {
                headers: {
                    Authorization: "Bearer " + auth.accessToken, "Content-Type": "multipart/form-data"
                }
            };
            await axiosPrivate.postForm("/faqs", form, headers);
            navigate("/faqs");
        } catch(err) {
            console.log(err);
        }
    }

    return (
        <div>
            <div style={{paddingBottom: "2rem"}}>
                <span className="relative flex justify-center">
                    <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-75"></div>
                    <span className="relative z-10 bg-white px-6">Add Faq</span>
                </span>
            </div>
            <div style={{paddingBottom: "1.5rem"}}>
                <Link to="/faqs">
                    <strong className="rounded border border-[#f3f4f7] bg-[#f3f4f7] px-3 py-1.5 text-[13px] font-medium text-black">
                        Back
                    </strong>
                </Link>
            </div>
            <form onSubmit={handleSubmit}>
                <div style={{display: "grid", rowGap: "1rem"}}>
                    <div>
                        <label htmlFor="question" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <textarea
                                value={question}
                                onChange={(e) => setQuestion(e.target.value)}
                                required
                                ref={qstnRef}
                                placeholder="Question"
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Question
                            </span>
                        </label>
                    </div>
                    <div>
                        <label htmlFor="answer" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <textarea
                                value={answer}
                                onChange={(e) => setAnswer(e.target.value)}
                                required
                                placeholder="Answer"
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Answer
                            </span>
                        </label>
                    </div>
                    <div>
                        <label htmlFor="File" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                onChange={(e) => setFile(e.target.files[0])}
                                type="file"
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Attach File
                            </span>
                        </label>
                    </div>
                </div>
                <div style={{display: "flex", paddingTop: "2rem", justifyContent: "end"}}>
                    <button>
                        <strong className="rounded border border-indigo-500 bg-indigo-500 px-3 py-1.5 text-[13px] font-medium text-white">
                            Submit
                        </strong>
                    </button>
                </div>
            </form>
        </div>
    )
}

export default AddFaq